import * as React from "react";

import { AccessReportsWizardProduct } from "@app/access-reports/shared";
import { QESButton, QESTextInput } from "@app/shared/qes-standards";
import { cloneDeep } from "lodash";
import { FlyoutFooter } from "@app/shared/Flyouts";

interface AccessReportsAdminAddProductAddSpecialtiesProps {
  hideSidePanel: () => void;
  onAddSpecialtiesClick: (specialties: string[]) => void;
  product: AccessReportsWizardProduct;
}

interface AccessReportsAdminAddProductAddSpecialtiesState {
  specialties: string[];
  specialty: string;
}

class AccessReportsAdminAddProductAddSpecialties extends React.Component<AccessReportsAdminAddProductAddSpecialtiesProps, AccessReportsAdminAddProductAddSpecialtiesState> {
  constructor(props: AccessReportsAdminAddProductAddSpecialtiesProps) {
    super(props);

    this.state = {
      specialties: [],
      specialty: "",
    };
  }

  public render() {
    const addSpecialtyValidationText: string = this.getAddSpecialtyValidationText();

    return (
      <React.Fragment>
        <div>
          <div className="row">
            <div className="col-12">
              <QESTextInput
                inputAppend={(
                  <QESButton
                    qesType="secondary"
                    className="p-1"
                    disabled={!this.getAddSpecialtyButtonValidity()}
                    qesTestId="access-reports-admin__add-specialties--input-add"
                    onClick={() => this.onAddSpecialtyClick()}
                  >
                    Add
                  </QESButton>
                )}
                testId="access-reports-admin__add-specialties--input"
                errorText={addSpecialtyValidationText}
                isValid={!addSpecialtyValidationText}
                label="Specialty"
                onChange={(e) => this.onSpecialtyInputChange(e)}
                unrequiredValidation={true}
                value={this.state.specialty}
              />

              {this.state.specialties.length > 0 &&
                <React.Fragment>
                  <hr />

                  {this.state.specialties.map((specialty, index) => (
                    <QESTextInput
                      inputAppend={(
                        <QESButton
                          className="p-1"
                          qesTestId={`access-reports-admin__add-specialties--remove-${index}`}
                          qesType="secondary-danger"
                          onClick={() => this.onRemoveSpecialtyClick(specialty)}
                        >
                          Remove
                        </QESButton>
                      )}
                      key={index}
                      readOnly
                      testId={`access-reports-admin__add-specialties--readonly-${index}`}
                      label={specialty}
                      hideLabel={true}
                      value={specialty}
                    />
                  ))}
                </React.Fragment>
              }
            </div>
          </div>
        </div>

        <FlyoutFooter
          submitButton={
            <QESButton
              className="ml-3"
              disabled={this.state.specialties.length < 1}
              onClick={() => this.onAddSpecialtiesClick()}
              qesTestId="access-reports-admin__add-specialties--add"
              qesType="primary"
            >
              Add
            </QESButton>
          }
        />
      </React.Fragment>
    );
  }

  private getAddSpecialtyButtonValidity = (): boolean => {
    const savedAccessCriterionNames: string[] = this.props.product.accessCriterion.map(x => x.name);
    const upcomingAccessCriterionNames: string[] = cloneDeep(this.state.specialties);
    const allAccessCriterionNames: string[] = savedAccessCriterionNames.concat(upcomingAccessCriterionNames);

    if (!!this.state.specialty &&
      !allAccessCriterionNames.includes(this.state.specialty)
    ) {
      return true;
    }
  }

  private getAddSpecialtyValidationText = (): string => {
    const savedAccessCriterionNames: string[] = this.props.product.accessCriterion.map(x => x.name);
    const upcomingAccessCriterionNames: string[] = cloneDeep(this.state.specialties);
    const allAccessCriterionNames: string[] = savedAccessCriterionNames.concat(upcomingAccessCriterionNames);

    if (allAccessCriterionNames.includes(this.state.specialty)) {
      return "A specialty with that name already exists";
    }
  }

  private onAddSpecialtiesClick = (): void => {
    this.props.onAddSpecialtiesClick(this.state.specialties);

    this.setState({
      specialties: [],
    });
  }

  private onAddSpecialtyClick = (): void => {
    const specialties: string[] = cloneDeep(this.state.specialties);
    specialties.push(this.state.specialty);

    this.setState({
      specialties,
      specialty: "",
    });
  }

  public onRemoveSpecialtyClick = (specialty: string): void => {
    const specialtiesClone: string[] = cloneDeep(this.state.specialties);
    const specialties: string[] = specialtiesClone.filter(x => x !== specialty);

    this.setState({
      specialties,
    });
  }

  private onSpecialtyInputChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    this.setState({
      specialty: event.target.value,
    });
  }
}

export { AccessReportsAdminAddProductAddSpecialties };
